<template>
  <div>
    <Dialog
      :visible.sync="holidayForm1"
      :style="{ width: '520px', overflowY: 'auto' }"
      header="Bank Holiday"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="holidayDate">Date*</label>
        <Calendar id="holidayDate" v-model="date" dateFormat="dd/mm/yy" :showIcon="true"
          :class="{ 'p-invalid': fieldError('holidayDate') }" />
        <small class="p-invalid" v-if="fieldError('holidayDate')">{{ fieldError('holidayDate') }}</small>
      </div>
      <div class="p-field">
        <label for="name">Name*</label>
        <InputText id="name" v-model="holiday.name" placeholder="e.g. Christmas Day"
          :class="{ 'p-invalid': fieldError('name') }" />
        <small class="p-invalid" v-if="fieldError('name')">{{ fieldError('name') }}</small>
      </div>

      <template #footer>
        <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reset" />
        <Button label="Save" icon="pi pi-check" class="p-button-text" @click="save" />
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="cancel" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { toIsoDate, fromIsoDate } from './bankHolidayDates'

export default {
  props: ['holidayToEdit', 'holidayForm', 'serverErrors'],
  data: () => ({
    holiday: {},
    date: null,
    submitted: false
  }),
  created() {
    this.reset()
  },
  computed: {
    holidayForm1: {
      set(val) {
        if (!val) this.cancel()
      },
      get() {
        return !!this.holidayForm
      }
    }
  },
  methods: {
    fieldError(field) {
      if (this.serverErrors && this.serverErrors[field]) return this.serverErrors[field]
      if (!this.submitted) return ''
      if (field === 'holidayDate' && !toIsoDate(this.date)) return 'Required.'
      if (field === 'name' && !(this.holiday.name || '').trim()) return 'Required.'
      return ''
    },
    reset() {
      this.holiday = this.holidayToEdit && this.holidayToEdit.id ? { ...this.holidayToEdit } : {}
      this.date = fromIsoDate(this.holiday.holidayDate)
      this.submitted = false
    },
    save() {
      this.submitted = true
      if (this.fieldError('holidayDate') || this.fieldError('name')) return
      this.$emit('save', { ...this.holiday, holidayDate: toIsoDate(this.date), name: this.holiday.name.trim() })
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>

<style></style>
